import React from "react";
import './UxSection.css';
import img_one from './images/1.png';import img_two from './images/2.png';
import ux_one from './images/ux3.jpg';
import img_three from './images/3.png';import img_four from './images/4.png';
import img_five from './images/5.png'; import img_six from './images/6.png';
import case_study_img from './images/case_study_2.jpg';
import workImg from './images/work.jpg';
import gifImg from './images//gif23 1.png';
import anotyImg from './images/atony.png';
import outSurance  from './images/web cover (2).png';
import booka from './images/booka.png'
import { Link } from "react-router-dom";

export default function UxSection(){
    return(
        <div className="ProjectSection project_section_parent_wrapper container-fluid py-4">
            <div className="container container-fluid-custom project_section_child_wrapper py-4">
                <h4 className="project_heading project_experience_heading font-weight-bold" style={{color:"black",fontWeight:800}}>
                    My Projects + Work Experience
                </h4>
                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                    <div className="d-none">
                        <h6 className="py-2 px-2">
                            My Projects
                        </h6>
                    </div>
                    <div className="d-none">
                        <h6 className="py-2 px-2">
                            Work Experience
                        </h6>
                    </div>
                </div>
                <div className="categories_section_one mt-3 d-none d-sm-none d-md-flex">
                    <p className="category_item_one border-outline-dark px-3 py-1">
                        Work Experience
                    </p>
                    <p className="category_item_one border-outline-dark px-3 py-1">
                        UX Design + Research + Writing
                    </p>
                </div>
                <p className="project_description2 d-none d-sm-none d-md-block">
                    kindly check Linkedin for more side projects : Faith Matlaba on linkedin
                </p>
                <div className="row gx-2 gy-4 project_row mt-5">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 project_col">
                        <div className="card ux_section_card">
                            <div className="card-img-top">
                                <img src={outSurance} alt="" className="img-fluid mx-auto project_col_img" />
                            </div>
                            <div className="card-body d-flex flex-column h-100">
                                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            Cover Letter
                                        </h6>
                                    </div>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            Branding
                                        </h6>
                                    </div>
                                </div>
                                <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        Portfolio
                                    </p>
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        Branding
                                    </p>
                                </div>
                                <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                    OUTSurance Custom Portfolio
                                </h4>
                                <p className="card-description ux_card_description mt-2">
                                    This is a form of a cover letter to showcase my branding skills and keen
                                    interest in securing and getting the current role being applied for 
                                    it would be dope to be given a minute shot at this
                                </p>
                                <p className="card-description ux_card_description d-none">
                                    Case study on how to convert visitors into customers
                                </p>
                                <div className="ux_section_btn_wrapper mt-2">
                                    <button className="btn btn-sm ux_section_view_btn bg-primary text-white px-4 py-2">
                                        <Link className='ux_section_link text-white' to='/outsurance'>
                                            <span>
                                                View Project
                                            </span>
                                        </Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 project_col">
                        <div className="card ux_section_card">
                            <div className="card-img-top">
                                <img src={booka} alt="" className="img-fluid mx-auto project_col_img" />
                            </div>
                            <div className="card-body d-flex flex-column h-100">
                                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            Branding
                                        </h6>
                                    </div>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            UX/UI
                                        </h6>
                                    </div>
                                </div>
                                <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                    <p className="category_item border-outline-primary bg-success text-white px-4 py-1">
                                        in Progress
                                    </p>
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        Branding
                                    </p>
                                </div>
                                <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                    Umuzi.Org Branding Brief
                                </h4>
                                <p className="card-description ux_card_description mt-2">
                                    This is a project brief that I participated in for Umuzi.Org Internship Application
                                    was given a brief to create brand identity for an app assisting 
                                    Artist During Covid 19 Times
                                </p>
                                <p className="card-description ux_card_description d-none">
                                    Case study on how to convert visitors into customers
                                </p>
                                <div className="ux_section_btn_wrapper mt-2">
                                    <button className="btn btn-sm ux_section_view_btn bg-primary text-white px-4 py-2">
                                        <Link className='ux_section_link text-white' to='https://www.figma.com/design/2S4mZn0oCeaUNKfN3uMbWO/FNB-HACKATHON?node-id=48-2&t=kY782t5apTJcNFiW-1'>
                                            <span>
                                                View Project
                                            </span>
                                        </Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 project_col">
                        <div className="card ux_section_card">
                            <div className="card-img-top">
                                <img src={ux_one} alt="" className="img-fluid mx-auto project_col_img" />
                            </div>
                            <div className="card-body d-flex flex-column h-100">
                                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            Work Project
                                        </h6>
                                    </div>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            UX Design + Research
                                        </h6>
                                    </div>
                                </div>
                                <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        Work Project
                                    </p>
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        UX Design + Research
                                    </p>
                                </div>
                                <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                    High Converting Landing Page
                                </h4>
                                <p className="card-description ux_card_description mt-2">
                                    A significant number of businesses are experiencing low conversion rates on their 
                                    landing pages ,this affect their marketing goals. 
                                    The objective of this case study is to fix that
                                </p>
                                <p className="card-description ux_card_description d-none">
                                    Case study on how to convert visitors into customers
                                </p>
                                <div className="ux_section_btn_wrapper mt-2">
                                    <button className="btn btn-sm ux_section_view_btn bg-primary text-white px-4 py-2">
                                        <Link className='ux_section_link text-white' to='/highConvertingPage'>
                                            <span>
                                                View Case Study
                                            </span>
                                        </Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="card ux_section_card">
                            <div className="card-img-top">
                                <img src={case_study_img} alt="" className="img-fluid mx-auto project_col_img" />
                            </div>
                            <div className="card-body d-flex flex-column h-100">
                                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            Personal Project
                                        </h6>
                                    </div>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            UX Design + Research
                                        </h6>
                                    </div>
                                </div>
                                <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        Personal Project
                                    </p>
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        UX Design + Research
                                    </p>
                                </div>
                                <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                    Effective Intuitive Banking App
                                </h4>
                                <p className="card-description ux_card_description mt-2">
                                    Many mobile banking applications suffer from a lack of intuitive design, leading to user frustration 
                                    and inefficiency. The objective of this case study is to solve that
                                </p>
                                <div className="ux_section_btn_wrapper mt-2">
                                    <button className="btn btn-sm ux_section_view_btn bg-success text-white px-4 py-2">
                                        <Link className='ux_section_link text-white' to='/mobileBankingAppPage'>
                                            <span>
                                                View Case Study
                                            </span>
                                        </Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-4">
                        <div className="card ux_section_card">
                            <div className="card-img-top py-3">
                                <img src={gifImg} alt="" className="img-fluid mx-auto project_col_img" />
                            </div>
                            <div className="card-body d-flex flex-column h-100">
                                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            Work Experience
                                        </h6>
                                    </div>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            UX + Development
                                        </h6>
                                    </div>
                                </div>
                                <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        Work Experience
                                    </p>
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        UX + Development
                                    </p>
                                </div>
                                <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                    A2Z Tech Solutions
                                </h4>
                                <p className="card-description ux_card_description mt-2">
                                    Part of the Marketing & R&D Team ,
                                    responsible for delivering colliterals for print + social 
                                    media . Responsible for UX design and development 
                                    of systems,web applications
                                </p>
                                <div className="ux_section_btn_wrapper mt-2">
                                    <button className="btn btn-sm ux_section_view_btn work_btn text-white px-4 py-2">
                                        <Link className='ux_section_link text-white' to='/experiencePage'>
                                            <span>
                                                Check It Out
                                            </span>
                                        </Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-4">
                        <div className="card ux_section_card">
                            <div className="card-img-top py-3">
                                <img src={anotyImg} alt="" className="img-fluid mx-auto project_col_img" />
                            </div>
                            <div className="card-body d-flex flex-column h-100">
                                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            Work Experience
                                        </h6>
                                    </div>
                                    <div>
                                        <h6 className="py-2 px-3">
                                            UX + Development
                                        </h6>
                                    </div>
                                </div>
                                <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        Work Experience
                                    </p>
                                    <p className="category_item border-outline-dark px-3 py-1">
                                        UX + Development
                                    </p>
                                </div>
                                <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                   Freelancing  Projects
                                </h4>
                                <p className="card-description ux_card_description mt-2">
                                    Outside my 925 job I am freelancing developing and designing 
                                    for start-ups and enterpreneurs ,this is my latest project 
                                    overseen from UX to development using React JavaScript
                                </p>
                                <div className="ux_section_btn_wrapper mt-2 d-flex" style={{columnGap:"2pt"}}>
                                    <button className="btn btn-sm ux_section_view_btn work_btn freelancing_btn text-white px-4 py-2">
                                        <Link className='ux_section_link text-white' to='https://snmoleleattorneys.com/'>
                                            <span>
                                                Check It Out
                                            </span>
                                        </Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}